//----------------------------
// is characteristics changed
//----------------------------
export default function isCharacteristicsChanged(original, now) {
  // console.log("----------------------------")
  // console.log("IN isCharacteristicsChanged")
  // console.log("----------------------------")
  // console.log("ORIGINAL...")
  // window.displayPairs(original)
  // console.log("----------------------------")
  // console.log("NOW...")
  // window.displayPairs(now)
  // console.log("----------------------------")
  // console.log("original.str_cur = " + original.str_cur)
  // console.log("now.str_cur = " + now.str_cur)
  // console.log("----------------------------")
  if (
    original.str_cur != now.str_cur ||
    original.con_cur != now.con_cur ||
    original.dex_cur != now.dex_cur ||
    original.siz_cur != now.siz_cur ||
    original.int_cur != now.int_cur ||
    original.pow_cur != now.pow_cur ||
    original.cha_cur != now.cha_cur
  ) {
    return true;
  } else {
    return false;
  }
}
